module.exports = __webpack_public_path__ + "assets/media/lunch.ae02c8a0.mp3";